import React from "react";
import "./CategoryPills.scss";

export type CategoryOption = {
  id: string | number;
  label: string;
};

type CategoryPillsProps = {
  options: CategoryOption[];
  selectedIndex: number;
  onSelect: (id: string | number, index: number) => void;
  rtl?: boolean;
};

const CategoryPills: React.FC<CategoryPillsProps> = ({
  options,
  selectedIndex,
  onSelect,
  rtl = false,
}) => (
  <div className={`category-pills ${rtl ? "category-pills--rtl" : ""}`}>
    {options.map((option, index) => (
      <button
        key={option.id}
        type="button"
        className={`category-pills__pill familysora600 ${
          selectedIndex === index ? "category-pills__pill--active" : ""
        }`}
        onClick={() => onSelect(option.id, index)}
        disabled={selectedIndex === index}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default CategoryPills;
